import { cloneDeep, merge } from 'lodash'
import { StateCreator } from 'zustand'

import { ECognitoGroups } from '~/models/auth'

type TOrganizationDefinition = {
  paymentTier: ECognitoGroups
  referralCode: string
  trialDaysLeft: number
}

type TOrganization = {
  organization: TOrganizationDefinition
}

export type TOrganizationState = TOrganization & {
  setOrganization(organization: Partial<TOrganizationDefinition>): void
}

export const initialOrganizationState: TOrganizationDefinition = {
  paymentTier: ECognitoGroups.customerFreePlan,
  referralCode: '',
  trialDaysLeft: 0,
}

const createOrganizationSlice: StateCreator<
  TOrganizationState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  organization: cloneDeep(initialOrganizationState),
  setOrganization: (organization) =>
    set(
      (state) => ({
        organization: cloneDeep(merge(state.organization, organization)),
      }),
      undefined,
      {
        type: 'setOrganization',
        organization,
      },
    ),
})

export default createOrganizationSlice
